<template xmlns="http://www.w3.org/1999/html">
	<div class="nakladnoyWholesale">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back') }}</b-button>
			</div>
			<div class="pull-right">
				<b-button v-if="$route.params.action === 'checking' && $can('change', 'warehouse-docStatus')" variant="success" class="mr-2" @click="saveAndFinishDoc">
					{{ $t('save-finish') }}
				</b-button>
				<b-button style="background-color: #9cf165" class="mr-2" @click="check" v-if="$route.params.action === 'checking'">
					<i class="fa fa-check"></i> {{ $t('checking') }}
				</b-button>
				<b-button variant="outline-dark" @click="submitPricePrint" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('incomes.create.prices')}}
				</b-button>
				<b-button variant="outline-dark" @click="submitBarcodePrint" class="mr-2">
					<i class="fa fa-print"></i> {{ $t('goods.barcode')}}
				</b-button>
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"/> {{ $t('Печать') }}
				</b-button>
			</div>
		</div>
		<br>
		<br>
		<div class="doc-body">
			<b-card class="p-1">
				<table style="width: 100%">
					<thead>
						<b-row>
							<b-col cols="4">
								<b>CentralAsia Megastar</b>
							</b-col>
							<b-col cols="4">
								<h5 style="text-align: center"><b>Приходная накладная</b></h5>
							</b-col>
							<b-col cols="4">
								<p id="currentDate" style="text-align: right; font-size: 11px">{{currentDate}}</p>
							</b-col>
						</b-row>
					</thead>
					<tbody>
						<br>
						<div v-if="checked" style="line-height: 5px">
							<b-row>
								<b-col cols="6">
									<b-row>
										<b-col cols="3">
											<p>Накладная :</p>
										</b-col>
										<b-col>
											<b>{{ item.regNumber }}</b>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="3">
											<p>Паставщик :</p>
										</b-col>
										<b-col>
											<b>{{ item.contragentName }}</b>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="3">
											<p>Куда :</p>
										</b-col>
										<b-col>
											<b>{{ item.toDepartmentName }}</b>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="3">
											<p>{{ $t('incomes.date') }} :</p>
										</b-col>
										<b-col>
											<b>{{ item.regDate }}</b>
										</b-col>
									</b-row>
								</b-col>
								<b-col cols="6">
									<div v-if="item.extraCostList && item.extraCostList.length > 0">
										<b-row v-for="(extraCost, index) in item.extraCostList" :key="`exttra-cost-${index}`">
											<b-col cols="5">
												<p>{{ extraCost.categoryName }} :</p>
											</b-col>
											<b-col>
												<b>{{ extraCost.currencyCost ? extraCost.currencyCost.toFixed(4) : '' }}</b> - <span>{{ extraCost.currencyName }}</span>
											</b-col>
										</b-row>
									</div>
									<b-row>
										<b-col cols="5">
											<p>Итоговый доп.расход :</p>
										</b-col>
										<b-col>
											<b>{{ item.extraCosts ? item.extraCosts.toFixed(4) : '' }}</b> - <span>{{ item.toDepCurrencyName }}</span>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="5">
											<p>Сч/фактура поставщика :</p>
										</b-col>
										<b-col>
											<b>{{ item.reason }}</b>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="5">
											<p>Номер ГТД :</p>
										</b-col>
										<b-col>
											<b>{{ item.numberGTD }}</b>
										</b-col>
									</b-row>
									<b-row v-if="item.currencyName !== 'UZS'">
										<b-col cols="5">
											<p>Валюта ({{ item.currencyName }}) :</p>
										</b-col>
										<b-col>
											<b>{{ currencyRate(item.currencyName) }}</b> - <span>UZS</span>
										</b-col>
									</b-row>
								</b-col>
							</b-row>
						</div>
						<br>
						<div class="mb-2" >
							<b-table  :items="item.whItems" class="text-center" id="gridContainer" :fields="fields" foot-clone hover striped bordered :busy="loading"  label-sort-asc="" label-sort-desc="" label-sort-clear="">
								<template #cell(index)="data">
									<span style="border: none;">{{ data.index+1 }}</span>
								</template>
								<template #cell(barcode)="data">
										<span>{{ data.item.barcode }}</span>
								</template>
								<template #cell(itemName)="data">
										<p>{{ data.item.itemName }}</p>
								</template>
								<template #cell(multiBarcodesString)="data">
										<span style="text-align: center" v-for="barcode in data.item.multiBarcodesString"><span>{{ barcode }}</span><br></span>
								</template>
								<template #cell(incomingPriceUsd)="data">
										<span style="text-align: center">{{ data.item.incomingPriceUsd.toFixed(4) }}</span>
								</template>
								<template #cell(incomingPriceUzs)="data">
										<span style="text-align: center">{{ data.item.selfExtraCosts ? (data.item.incomingPriceUzs + data.item.selfExtraCosts).toFixed(4) : data.item.incomingPriceUzs.toFixed(4) }}</span>
								</template>
								<template #cell(priceUzs)="data">
										<span style="text-align: center" v-if="data.item.priceUzs">{{ data.item.priceUzs.toFixed(4) }}</span>
										<span style="text-align: center" v-else-if="data.item.currentPrice">{{ data.item.currentPrice.toFixed(4) }}</span>
										<span style="text-align: center" v-else>0</span>
								</template>
								<template #cell(count)="data">
										<span >{{ data.item.count }}
											<b-badge :variant="data.item.equal == '-' ? 'danger' : 'success'" v-if="data.item.newCount>0">
												{{ `${data.item.equal} ${data.item.newCount}` }}
											</b-badge>
											<i v-else-if="data.item.newCount == 0" class="fa fa-check text-success"></i>
										</span>
								</template>
								<template #cell(subName)="data">
										<span style="text-align: center">{{ (data.item.count * data.item.incomingPriceUsd).toFixed(4) }}</span>
								</template>
								<template #cell(remaining)="data">
										<span style="text-align: center">{{ data.item.selfExtraCosts ? (((data.item.incomingPriceUzs) + data.item.selfExtraCosts) * data.item.count).toFixed(4) : (data.item.incomingPriceUzs * data.item.count).toFixed(4) }}</span>
								</template>
								<template #cell(remaining1)="data">
											<span v-if="data.item.priceUzs">{{ (data.item.priceUzs * data.item.count).toFixed(4) }}</span>
											<span v-else-if="data.item.currentPrice">{{ (data.item.currentPrice * data.item.count).toFixed(4) }}</span>
											<span v-else>0</span>
								</template>
								<template #foot(index)="data">
									<span style="border: none;">{{""}}</span>
								</template>
								<template #foot(barcode)="data">
									{{""}}
								</template>
								<template #foot(itemName)="data">
									{{""}}
								</template>
								<template #foot(multiBarcodesString)="data">
									{{""}}
								</template>
								<template #foot(incomingPriceUsd)="data">
									{{""}}
								</template>
								<template #foot(incomingPriceUzs)="data">
									{{""}}
								</template>
								<template #foot(priceUzs)="data">
									<b>ИТОГО на сумму:</b>
								</template>
								<template #foot(count)="data">
									<b>{{ Count }}</b>
								</template>
								<template #foot(subName)="data">
									<b>{{ IncomePriceUzs.toFixed(4) }}</b>
								</template>
								<template #foot(remaining)="data">
									<b>{{ plus.toFixed(4) }}</b>
								</template>
								<template #foot(remaining1)="data">
									<b>{{ Price.toFixed(4) }}</b>
								</template>
							</b-table>
							<b-button  class="float-right mt-1 exs hidden-print" v-if="item.whItems.length > 0" @click="excelExport1('gridContainer', ' Приходная накладная')" variant="primary" :disabled="loading">{{ $t('excel-export.download-excel') }}</b-button>
						</div>
						<br>
						<div>
							<b-row>
								<b-col cols="3">
									<p>Суммовой эквивалент (прод.суммы)</p>
								</b-col>
								<b-col cols="8">
									<b>{{ (Price * currencyEur) | currency({symbol: '', fractionCount: 2, symbolPosition: 'back'}) }} UZS</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>Сумма по инвойсной цене</p>
								</b-col>
								<b-col cols="8">
									<b>{{ number_to_string(Math.abs(IncomePriceUzs.toFixed(2)), item.currencyName) ? number_to_string(Math.abs(IncomePriceUzs.toFixed(2)), item.currencyName) : 0 }}</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>Сумма по приходной цене</p>
								</b-col>
								<b-col cols="8">
									<b>{{ number_to_string1(Math.abs(plus.toFixed(2))) ? number_to_string1(Math.abs(plus.toFixed(2))) : 0 }}</b>
								</b-col>
							</b-row>
							<b-row>
								<b-col cols="3">
									<p>Сумма по продажной цене</p>
								</b-col>
								<b-col cols="8">
									<b>{{ number_to_string1(Math.abs(Price.toFixed(2))) ? number_to_string1(Math.abs(Price.toFixed(2))) : 0 }}</b>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col>
									<b>Сдал_________________________________________</b>
								</b-col>
								<b-col>
									<b>Руководитель______________________________</b>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col>
									<b>Принял_______________________________________</b>
								</b-col>
								<b-col>
									<b>Гл.бухгалтер_________________________________</b>
								</b-col>
							</b-row>
							<b-row class="mt-4">
								<b-col>
									<b>Составил_______________________________________</b>
								</b-col>
								<b-col></b-col>
							</b-row>
						</div>
					</tbody>
				</table>
			</b-card>
			<b-form-file
				accept=".xlsx, xls"
				v-model="file"
				style="display: none"
				@change="processFile($event)"
				id="fileUpload"
			></b-form-file>
		</div>
	</div>
</template>

<script>
import {BTable, VBTable} from "bootstrap-vue";
import WhDocument from "../../../../services/wh-document.service";
import XlsxWorkbook from "vue-xlsx/dist/components/XlsxWorkbook";
import XlsxSheet from "vue-xlsx/dist/components/XlsxSheet";
import XlsxDownload from "vue-xlsx/dist/components/XlsxDownload";
import {XlsxRead, XlsxJson} from "vue-xlsx/dist/vue-xlsx.es.js"
import XLSX from "xlsx"
import items from "../items";
import MyCurrencyInput from "../../../my-currency-input/my-currency-input";
import {mapActions} from "vuex";
export default {
	name: 'naklodnoyNew',
	components: {
		MyCurrencyInput,
		XlsxRead, XlsxJson,
		XlsxWorkbook,
		XlsxSheet,
		BTable,
		VBTable,
		XlsxDownload

	},
	data() {
		return {
			currentDate: '',
			regDate: null,
			prices: [],
			checked: true,
			loading: false,
			excelItem: [],
			Id:null,
			fields:[
				{key: 'index', label: '№', class: 'text-center',visible: true },
				{key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'itemName', label: this.$t('goods.name'), class: 'text-center', visible: true,sortable: true},
				{key: 'multiBarcodesString', label: this.$t('goods.barcode'), class: 'text-center', visible: true,sortable: true},
				{key: 'incomingPriceUsd', label: this.$t('goods.inv-cent'), class: 'text-center', visible: true,sortable: true},
				{key: 'incomingPriceUzs', label: this.$t('goods.kirim-cent'), class: 'text-center', visible: true,sortable: true},
				{key: 'priceUzs', label: this.$t('goods.sale-cent'), class: 'text-center', visible: true,sortable: true,},
				{key: 'count', label: this.$t('sale.kol-vo'), class: 'text-center', visible: true,sortable: true},
				{key: 'subName', label: this.$t('goods.invSumma'), class: 'text-center', visible: true,sortable: true},
				{key: 'remaining', label: this.$t("goods.kirimCent"), class: 'text-center', visible: true,sortable: true},
				{key: 'remaining1', label: this.$t("goods.saleCent"), class: 'text-center', visible: true,sortable: true},
			],
			item: {
				whItems: []
			},
			time:'',
			priceItems: [],
			depId: null,
			file: null,
			totalItemSum: 0,
			dataForExcel: [],
			excelName: 'Excel sheet',
			search: {
				limit: 10,
				page: 1
			}
		}
	},
	computed: {
		Count() {
			let total = this.item.whItems.map(e => {
				return e.count
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		IncomePriceUzs() {
			let total = this.item.whItems.map(e => {
				return e.incomingPriceUsd * e.count
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		plus() {
			let total = this.item.whItems.map(e => {
				let s
				if (e.selfExtraCosts) {
					s = (e.incomingPriceUzs + e.selfExtraCosts) * e.count
				} else {
					s = e.incomingPriceUzs * e.count
				}
				return s
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		Price() {
			let price = false
			let total = this.item.whItems.map(e => {
				if (e.priceUzs) {
					let s = e.priceUzs * e.count
					price = true
					return s
				} else if (e.currentPrice) {
					let t = e.currentPrice * e.count
					return t
				}
			});
			let sum = 0
			for (let i = 0; i < total.length; i++) {
				sum += parseFloat(total[i])
			}
			return sum
		},
		currencyEur() {
			let price = 0
			this.prices.forEach(r => {
				if (r.currencyId === 27) {
					price = r.rate
				}
			})
			return price
		}
	},
	methods: {
		...mapActions('warehouse', ['setPriceWhItems']),
		getCurrentDate() {
			var today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0');
			var yyyy = today.getFullYear();
			let hours =  new Date().getHours(),
				minutes = new Date().getMinutes(),
				seconds = new Date().getSeconds();
			hours = hours.toString().length===1?`0${hours}`:`${hours}`
			minutes = minutes.toString().length===1?`0${minutes}`:`${minutes}`
			seconds = seconds.toString().length===1?`0${seconds}`:`${seconds}`
			this.currentDate = `${dd}-${mm}-${yyyy} ${hours}:${minutes}:${seconds}`
			return true;
		},
		submitPricePrint() {
			let items = {};
			items.status = true;
			items.data = JSON.parse(JSON.stringify(this.item.whItems));
			items.data.forEach((item,index) => {
				items.data[index].count = parseInt(item.count)
			});
			this.setPriceWhItems(items);
			this.$router.push(`/warehouse-management/price/print`);
		},
		excelExport(tableID, filename = '') {

			var downloadLink;

			var dataType = 'text/xls;charset=UTF-8';
			//var dataType = 'application/vnd.ms-excel';
			var tableSelect = document.getElementById(tableID);
			var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

			// Specify file name
			filename = filename ? filename + '.xls' : 'excel_data.xls';

			// Create download link element
			downloadLink = document.createElement("a");

			document.body.appendChild(downloadLink);

			if (navigator.msSaveOrOpenBlob) {
				var blob = new Blob(['\ufeff', tableSelect], {
					encoding: "utf-8",
					type: dataType
				});
				navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				// Create a link to the file
				downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

				// Setting the file name
				downloadLink.download = filename;

				//triggering the function
				downloadLink.click();
			}
		},
		excelExport1(tableID, filename = '') {
			var uri = 'data:application/vnd.ms-excel;base64,',
				template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
				base64 = function(s) {
					return window.btoa(unescape(encodeURIComponent(s)))
				},
				format = function(s, c) {
					return s.replace(/{(\w+)}/g, function(m, p) {
						return c[p];
					})
				}
			var toExcel = document.getElementById(tableID).innerHTML;
			var ctx = {
				worksheet: name || '',
				table: toExcel
			};
			var link = document.createElement("a");
			link.download = `${filename}.xls`;
			link.href = uri + base64(format(template, ctx))
			link.click();
		},
		submitBarcodePrint() {
			this.$router.push(`/warehouse-management/income/barcode/${this.$route.params.id}`);


		},
		saveAndFinishDoc() {
			WhDocument.saveAndFinishIncomeDoc(this.$route.params.id).then(res => {
				this.goBackToFrom();
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		goBackToFrom() {
			this.$router.back();
		},
		async print() {
			await this.getCurrentDate();
			window.print();
		},
		check() {
			this.$router.push(`/warehouse-management/income/views/${this.Id}`)
		},
		currencyRate(name) {
			let price = 0
			this.prices.forEach(r => {
				if (name == r.currencyName) {
					price = r.rate
				}
			})
			return price
		},
		exportToExcel() {
			this.dataForExcel = []
			this.loaders = true
			setTimeout(async () => {
				await WhDocument.get(this.item.id).then(response => {
					for (let j = 0; j < response.data.whItems.length; j++) {
						let data = {
							'Спец-код': response.data.whItems[j].barcode,
							'Количество': response.data.whItems[j].count,
							'Продажная цена': response.data.whItems[j].currentPrice,
							'Новая приходная цена': response.data.whItems[j].newIncomePrice,
							'Новая продажная цена': response.data.whItems[j].priceUzs
						}
						this.dataForExcel.push(data)
					}
					this.loaders = false
				}).catch(error => {
					this.loaders = false
				})
			}, 1000);
		},
		addButton() {
			document.querySelector("#fileUpload").click()
		},
		get() {
			if (this.$can('get', 'warehouse-document')) {
				let data = {
					limit: 1000,
					page: 1,
					value: ''
				}
				return WhDocument.getWithPrices(this.$route.params.id, data).then(response => {
					this.item = response.data;
					this.Id = response.data.id
					this.sumPrice(this.item);
					this.sumIncome(this.item);
				}).catch(error => {
					// this.loader = false
				})
			}
		},
		number_to_string(_number, name) {
			let vm = this;
			var _arr_numbers = new Array();
			_arr_numbers[1] = new Array('',
				vm.$t('number_to_string.1'),
				vm.$t('number_to_string.2'),
				vm.$t('number_to_string.3'),
				vm.$t('number_to_string.4'),
				vm.$t('number_to_string.5'),
				vm.$t('number_to_string.6'),
				vm.$t('number_to_string.7'),
				vm.$t('number_to_string.8'),
				vm.$t('number_to_string.9'),
				vm.$t('number_to_string.10'),
				vm.$t('number_to_string.11'),
				vm.$t('number_to_string.12'),
				vm.$t('number_to_string.13'),
				vm.$t('number_to_string.14'),
				vm.$t('number_to_string.15'),
				vm.$t('number_to_string.16'),
				vm.$t('number_to_string.17'),
				vm.$t('number_to_string.18'),
				vm.$t('number_to_string.19'));

			_arr_numbers[2] = new Array('', '',
				vm.$t('number_to_string.20'),
				vm.$t('number_to_string.30'),
				vm.$t('number_to_string.40'),
				vm.$t('number_to_string.50'),
				vm.$t('number_to_string.60'),
				vm.$t('number_to_string.70'),
				vm.$t('number_to_string.80'),
				vm.$t('number_to_string.90')
			);
			_arr_numbers[3] = new Array('',
				vm.$t('number_to_string.100'),
				vm.$t('number_to_string.200'),
				vm.$t('number_to_string.300'),
				vm.$t('number_to_string.400'),
				vm.$t('number_to_string.500'),
				vm.$t('number_to_string.600'),
				vm.$t('number_to_string.700'),
				vm.$t('number_to_string.800'),
				vm.$t('number_to_string.900'),
			);

			function number_parser(_num, _desc) {
				var _string = '';
				var _num_hundred = '';
				if (_num.length == 3) {
					_num_hundred = _num.substr(0, 1);
					_num = _num.substr(1, 3);
					_string = _arr_numbers[3][_num_hundred] + ' ';
				}
				if (_num < 20) _string += _arr_numbers[1][parseFloat(_num)] + ' ';
				else {
					var _first_num = _num.substr(0, 1);
					var _second_num = _num.substr(1, 2);
					_string += _arr_numbers[2][_first_num] + ' ' + _arr_numbers[1][_second_num] + ' ';
				}
				switch (_desc) {
					case 0:
						var _last_num = parseFloat(_num.substr(-1));
						// if (_last_num == 1) _string += vm.$t('number_to_string.currency1');
						// else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.currency2');
						// else _string += vm.$t('number_to_string.currency3');
						break;
					case 1:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.thousand1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.thousand2');
						else _string += vm.$t('number_to_string.thousand3');
						_string = _string.replace(vm.$t('number_to_string.one1'), vm.$t('number_to_string.one2'));
						_string = _string.replace(vm.$t('number_to_string.two1'), vm.$t('number_to_string.two2'));
						break;
					case 2:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.million1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.million2');
						else _string += vm.$t('number_to_string.million3');
						break;
					case 3:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.billion1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.billion2');
						else _string += vm.$t('number_to_string.billion3');
						break;
				}
				_string = _string.replace('  ', ' ');
				return _string;
			}

			function decimals_parser(_num) {
				var _first_num = _num.substr(0, 1);
				var _second_num = parseFloat(_num.substr(1, 1));
				var _string = ' ' + _first_num + _second_num;
				// if (_second_num == 1) _string += vm.$t('number_to_string.penny1');
				// else if (_second_num > 1 && _second_num < 5) _string += vm.$t('number_to_string.penny2');
				// else _string += vm.$t('number_to_string.penny3');
				_string+=' '
				if (name == 'UZS') _string += vm.$t('number_to_string.penny3')
				else _string += vm.$t('number_to_string.cent')
				return _string;
			}

			if (!_number || _number == 0) return false;
			if (typeof _number !== 'number') {
				_number = _number.replace(',', '.');
				_number = parseFloat(_number);
				if (isNaN(_number)) return false;
			}
			_number = _number.toFixed(4);
			if (_number.indexOf('.') != -1) {
				var _number_arr = _number.split('.');
				var _number = _number_arr[0];
				var _number_decimals = _number_arr[1];
			}
			var _number_length = _number.length;
			var _string = '';
			var _num_parser = '';
			var _count = 0;
			for (var _p = (_number_length - 1); _p >= 0; _p--) {
				var _num_digit = _number.substr(_p, 1);
				_num_parser = _num_digit + _num_parser;

				if ((_num_parser.length == 3 || _p == 0) && !isNaN(parseFloat(_num_parser))) {

					if (_num_parser !== "000") {
						_string = number_parser(_num_parser, _count) + _string;
					}

					_num_parser = '';
					_count++;

				}
			}
			// if (!_string.includes('сум') && !_string.includes('сўм')) {
			// 	_string += this.$t('number_to_string.currency3');
			// }

			if (name == 'UZS') {
				_string += 'сумов';
			} else if (name == 'USD') {
				_string += 'долларов';
			} else if (name == 'EUR') {
				_string += 'евро';
			} else if (name == 'RUB') {
				_string += 'рубль';
			} else if (name == 'GBR') {
				_string += 'фунт';
			}

			if (_number_decimals) _string += decimals_parser(_number_decimals);
			return _string.charAt(0).toUpperCase() + _string.slice(1);
		},
		number_to_string1(_number) {
			let vm = this;
			var _arr_numbers = new Array();
			_arr_numbers[1] = new Array('',
				vm.$t('number_to_string.1'),
				vm.$t('number_to_string.2'),
				vm.$t('number_to_string.3'),
				vm.$t('number_to_string.4'),
				vm.$t('number_to_string.5'),
				vm.$t('number_to_string.6'),
				vm.$t('number_to_string.7'),
				vm.$t('number_to_string.8'),
				vm.$t('number_to_string.9'),
				vm.$t('number_to_string.10'),
				vm.$t('number_to_string.11'),
				vm.$t('number_to_string.12'),
				vm.$t('number_to_string.13'),
				vm.$t('number_to_string.14'),
				vm.$t('number_to_string.15'),
				vm.$t('number_to_string.16'),
				vm.$t('number_to_string.17'),
				vm.$t('number_to_string.18'),
				vm.$t('number_to_string.19'));

			_arr_numbers[2] = new Array('', '',
				vm.$t('number_to_string.20'),
				vm.$t('number_to_string.30'),
				vm.$t('number_to_string.40'),
				vm.$t('number_to_string.50'),
				vm.$t('number_to_string.60'),
				vm.$t('number_to_string.70'),
				vm.$t('number_to_string.80'),
				vm.$t('number_to_string.90')
			);
			_arr_numbers[3] = new Array('',
				vm.$t('number_to_string.100'),
				vm.$t('number_to_string.200'),
				vm.$t('number_to_string.300'),
				vm.$t('number_to_string.400'),
				vm.$t('number_to_string.500'),
				vm.$t('number_to_string.600'),
				vm.$t('number_to_string.700'),
				vm.$t('number_to_string.800'),
				vm.$t('number_to_string.900'),
			);

			function number_parser(_num, _desc) {
				var _string = '';
				var _num_hundred = '';
				if (_num.length == 3) {
					_num_hundred = _num.substr(0, 1);
					_num = _num.substr(1, 3);
					_string = _arr_numbers[3][_num_hundred] + ' ';
				}
				if (_num < 20) _string += _arr_numbers[1][parseFloat(_num)] + ' ';
				else {
					var _first_num = _num.substr(0, 1);
					var _second_num = _num.substr(1, 2);
					_string += _arr_numbers[2][_first_num] + ' ' + _arr_numbers[1][_second_num] + ' ';
				}
				switch (_desc) {
					case 0:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.eur');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.eur');
						else _string += vm.$t('number_to_string.eur');
						break;
					case 1:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.thousand1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.thousand2');
						else _string += vm.$t('number_to_string.thousand3');
						_string = _string.replace(vm.$t('number_to_string.one1'), vm.$t('number_to_string.one2'));
						_string = _string.replace(vm.$t('number_to_string.two1'), vm.$t('number_to_string.two2'));
						break;
					case 2:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.million1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.million2');
						else _string += vm.$t('number_to_string.million3');
						break;
					case 3:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.billion1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.billion2');
						else _string += vm.$t('number_to_string.billion3');
						break;
				}
				_string = _string.replace('  ', ' ');
				return _string;
			}

			function decimals_parser(_num) {
				var _first_num = _num.substr(0, 1);
				var _second_num = parseFloat(_num.substr(1, 1));
				var _string = ' ' + _first_num + _second_num;
				_string+=' '
				if (_second_num == 1) _string += vm.$t('number_to_string.cent');
				else if (_second_num > 1 && _second_num < 5) _string += vm.$t('number_to_string.cent');
				else _string += vm.$t('number_to_string.cent');
				return _string;
			}

			if (!_number || _number == 0) return false;
			if (typeof _number !== 'number') {
				_number = _number.replace(',', '.');
				_number = parseFloat(_number);
				if (isNaN(_number)) return false;
			}
			_number = _number.toFixed(4);
			if (_number.indexOf('.') != -1) {
				var _number_arr = _number.split('.');
				var _number = _number_arr[0];
				var _number_decimals = _number_arr[1];
			}
			var _number_length = _number.length;
			var _string = '';
			var _num_parser = '';
			var _count = 0;
			for (var _p = (_number_length - 1); _p >= 0; _p--) {
				var _num_digit = _number.substr(_p, 1);
				_num_parser = _num_digit + _num_parser;

				if ((_num_parser.length == 3 || _p == 0) && !isNaN(parseFloat(_num_parser))) {

					if (_num_parser !== "000") {
						_string = number_parser(_num_parser, _count) + _string;
					}

					_num_parser = '';
					_count++;

				}
			}
			// if (!_string.includes('сум') && !_string.includes('сўм')) {
			// 	_string += this.$t('number_to_string.eur');
			// }

			if (_number_decimals) _string += decimals_parser(_number_decimals);
			return _string.charAt(0).toUpperCase() + _string.slice(1);
		},
	},
	async created() {
		this.loading = true
		// this.get()
		// this.kirim()
		this.getCurrentDate();
		let data = {
			limit: 100000,
			page: 1,
			value: ''
		}
			let tim = new Date()
			tim.getHours();
			this.time = tim

		await WhDocument.getWithPrices(this.$route.params.id, data).then(res => {
			// if (this.$route.params.action === 'view') {
				this.item = res.data
				this.Id = res.data.id
			// }
			this.priceItems = res.data.whItems
			this.regDate = res.data.regDate
			this.loading = false
		})
		let d = {
			date: this.regDate
		}
		await WhDocument.getPrices(d).then(res => {
			this.prices = res.data
			this.loading = false
		})
	},
	watch: {
		totalItemSum: {
			handler(newValue) {
				this.param.totalItemSum = newValue;
				this.param.totalItemInText = this.number_to_string(Math.abs(newValue))
			}
		},
	}
}
</script>

<style scoped lang="scss">
.spinner-wrapper {
	position: absolute;
	background: rgba(32, 28, 32, 0.49);
	left: 0;
	right: 0;
	text-align: center;
	top: 0;
	bottom: 0;
	padding-top: 35px;
	z-index: 5;
}

.nakladnoyWholesale {
	margin: 0 20px;
}

@page  {
	margin: 1cm;
}

#currentDate {
	display: none;
}

@media print {
	.hidden-print {
		display: none;
	}
	#currentDate {
		display: inline-table;
		position: absolute;
		right: 10px;
	}
}
	.exs{
		display: none;
	}
	.mt {
		padding-top: 200px !important;
	}
	.card {
		box-shadow: none;
	}
	footer {
		page-break-after: always;
		margin-top: 20px;
	}


.saldoInfoTexts {
	width: 88%;

	span {
		display: inline-block;
		width: 18%;
	}

	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 80%;
	}

	/*input.bottomBorderedInput:focus {
	border-color: green
	}*/
}


.signsOfAccountants {
	input.bottomBorderedInput {
		outline: 0;
		border-width: 0 0 .5px;
		border-color: black;
		width: 40%;
	}

}

input.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

h6.bottomBorderedInput {
	outline: 0;
	border-width: 0 0 .5px;
	border-color: black;

	&.width70 {
		width: 70px;
	}

	&.width80 {
		width: 80px;
	}

	&.forDate {
		width: 40px;
		text-align: right;

		&.borderRed {
			border-color: red;
			color: red;
		}
	}
}

//#nakladnoyTableWrapper {
//	.table {
//		td, th {
//			border: 1px solid black;
//			vertical-align: middle;
//
//			&.borderRightNone {
//				border-right: none;
//			}
//
//			&.borderLeftNone {
//				border-left: none;
//			}
//
//			&.borderTopNone {
//				border-top: none;
//			}
//
//			&.borderBottomNone {
//				border-bottom: none;
//			}
//
//			color: black;
//		}
//
//		#moldavianItemsHeader {
//			th {
//				font-size: 9px;
//				border-bottom: none;
//			}
//
//			.width27 {
//				width: 27%;
//			}
//		}

//		#russianItemsHeader {
//			th {
//				font-size: 9px;
//				border-top: none;
//			}
//
//			.greyText {
//				color: #999999;
//			}
//		}
//
//		.docItemRow {
//			td {
//				text-align: right;
//
//				&.docItemUnit {
//					text-align: center;
//				}
//
//				&:first-child {
//					text-align: unset;
//				}
//
//				padding: 0 .5rem;
//			}
//		}
//
//		th {
//			font-size: 11px;
//		}
//
//
//		.moldavianText {
//			font-weight: bold;
//		}
//
//		.fontWeightNormal {
//			font-weight: normal;
//		}
//
//		tfoot {
//			th, td {
//				font-weight: bold;
//				font-size: 11px;
//				text-align: right;
//
//				&.textAlignCenter {
//					text-align: center;
//				}
//
//				&:first-child {
//					text-align: unset;
//				}
//
//				padding: 0 .5rem;
//			}
//		}
//	}
//}

.customSize {
	font-size: 10px;
}

.customSizeItem {
	font-size: 12px;
}

.nobr {
	white-space: nowrap;
}

.strong {
	font-weight: bold;
}

#docUpperPart {
	margin-bottom: .5rem;

	#docImgLogoName {
		margin-left: 32%;
		width: 300px;
		height: auto;
	}

	#docImgLogo {
		width: 180px;
		height: 70px;
	}

	#docUpperPartLeft {
		#docUpperPartTxt {
			margin-top: .5rem;
			display: inline-block;
			width: 30%;

		}

		#barcodeImgForSeria {
			cursor: pointer;
			display: inline-block;
			width: 30%;

			svg {
				vertical-align: bottom;
				width: 46mm !important;
				height: auto !important;

				g {
					text {
						font-size: 14px !important;
						transform: translateY(46px) !important;
					}
				}
			}
		}

		display: inline-block;
		width: 74%;

		#seriaInputForBarcode {
			display: inline-block;

			input {
				margin-left: .5rem;
				width: 10rem;
				height: 1.2rem;
			}
		}
	}

	#docUpperPartRight {
		display: inline-block;
		width: 26%;
		vertical-align: top;
		text-align: right;

		#rightPartTxt {
			font-size: 10px;
		}
	}
}
</style>
